import React from "react";
import src from "../../assets/images/noun-house-rental-355698.png";
const Logo = (props) => {
	return <img src={src} className="object-contain size-[50px] select-none" draggable={false} alt="logo" {...props} />;
};

export default Logo;
